module.exports = __webpack_public_path__ + "img/neumaticos.958b13d8.jpg";